import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TransportPostalCodeState, TransportPricingRequest, TransportPricingResponse } from './models';
import { TransportPricingOrderReturnRequest } from './models/transport-pricing-order-return-request.model';
import { TransportPricingOrderReturnResponse } from './models/transport-pricing-order-return-response.model';

@Injectable({
	providedIn: 'root',
})
export class TransportPricingService {
	private postalCodeStates: TransportPostalCodeState[];
	private transportPostalCodeStateSubject = new Subject<TransportPostalCodeState>();

	constructor(private httpClient: HttpClient) {
		this.postalCodeStates = [];
	}

	public getTransportPostalCodeStates() {
		return this.postalCodeStates;
	}

	public getTransportPostalCodeState() {
		return this.transportPostalCodeStateSubject.asObservable();
	}

	public getTransportCostForOrderReturn(request: TransportPricingOrderReturnRequest) {
		return this.httpClient.post<TransportPricingOrderReturnResponse>(`/webapi/returntransportprice`, request);
	}

	public getTransportPricing(request: TransportPricingRequest) {
		return this.httpClient.post<TransportPricingResponse[]>(`/webapi/transportprice`, request).pipe(
			tap((prices: TransportPricingResponse[]) => {
				const errorJobsiteZipCodeIndex = prices.findIndex((item) => item.ErrorMessage?.includes('GOOGLEAPI_'));
				const validJobsiteZip = errorJobsiteZipCodeIndex === -1;
				const postalCodeState: TransportPostalCodeState = {
					countryCode: request.MarketId,
					isValid: validJobsiteZip,
					postalCode: request.JobsitePostalCode,
				};
				this.setTransportPostalCodeState(postalCodeState);
			}),
		);
	}

	public setTransportPostalCodeState(postalCodeState: TransportPostalCodeState) {
		const index = this.postalCodeStates.findIndex(
			(item) => item.postalCode === postalCodeState.postalCode && item.countryCode === postalCodeState.countryCode,
		);
		if (index >= 0) {
			this.postalCodeStates[index].isValid = postalCodeState.isValid;
		} else {
			this.postalCodeStates.push(postalCodeState);
		}
		this.transportPostalCodeStateSubject.next(postalCodeState);
	}
}
